import { createContext, useState } from "react";
import { getLimitIncreaseRequests, getLimitsFitBank, setLimitsFitBank } from "../services/pix.service";
import { toast } from "react-toastify";

export const LimitContext = createContext({});

export function LimitProvider({ children }) {
  const [originalLimits, setOriginalLimits] = useState({
    pix: { daily: 0, overnight: 0, transaction: 0, titular: 0 },
    ted: { daily: 0, transaction: 0 }
  });

  const [currentLimits, setCurrentLimits] = useState({
    pix: { daily: 0, overnight: 0, transaction: 0, titular: 0 },
    ted: { daily: 0, transaction: 0 }
  });

  const [limits, setLimits] = useState({
    pix: { daily: 0, overnight: 0, transaction: 0, titular: 0 },
    ted: { daily: 0, transaction: 0 }
  });

  const [limitIncreaseRequests, setLimitIncreaseRequests] = useState();

  const LIMIT_TYPE_MAP = {
    0: 'daily',
    3: 'overnight',
    4: 'transaction',
    5: 'titular'
  };

  const OPERATION_TYPE_MAP = {
    40: 'pix',
    3: 'ted'
  };

  const [loading, setLoading] = useState(false);

  const fetchLimits = async () => {
    try {
      setLoading(true);
      const response = await getLimitsFitBank();

      const { originalLimits, currentLimits, limits } = mapLimitsData(response);

      setOriginalLimits(originalLimits);
      setCurrentLimits(currentLimits);
      setLimits(limits);

    } catch (error) {
      console.error('Erro ao buscar limites:', error);
      toast.error('Ocorreu um erro ao buscar os limites');
    } finally {
      setLoading(false);
    }
  };

  function mapLimitsData(limitsArray) {
    const originalLimits = { pix: {}, ted: {} };
    const currentLimits = { pix: {}, ted: {} };
    const limits = { pix: {}, ted: {} };

    limitsArray.forEach(item => {
      const opKey = OPERATION_TYPE_MAP[item.operationType];
      const limitKey = LIMIT_TYPE_MAP[item.limitType];

      if (!opKey || !limitKey) return;

      originalLimits[opKey][limitKey] = item.maxLimitValue;
      currentLimits[opKey][limitKey] = Number(item.clientLimitValue);
      limits[opKey][limitKey] = Number(item.clientLimitValue);
    });

    return { originalLimits, currentLimits, limits };
  }

  const updateLimits = async (data) => {
    try {
      setLoading(true);
      const response = await setLimitsFitBank(data);
      validateResponse(response);
      await fetchLimitIncreaseRequests();
      return true;
    } catch (error) {
      toast.error('Ocorreu um erro ao solicitar aumento dos limites');
    } finally {
      setLoading(false);
    }
  };


  const fetchLimitIncreaseRequests = async () => {
    const response = await getLimitIncreaseRequests();
    setLimitIncreaseRequests(response.data);
  }

  const validateResponse = (response) => {
    const successes = [];
    const failures = [];

    Object.keys(response.data).forEach((limitKey) => {
      const result = response.data[limitKey];
      if (!result) return;

      const limitNameMap = {
        daily: 'Limite diário',
        overnight: 'Limite noturno',
        transaction: 'Limite por transação',
        titular: 'Limite para titular'
      };

      const readableName = limitNameMap[limitKey] || limitKey;

      if (result.ok) {
        successes.push(readableName);
      } else {
        failures.push({ name: readableName, message: result.message || 'Erro desconhecido' });
      }
    });

    if (successes.length && failures.length) {
      toast.warn(
        `Algumas solicitações foram concluídas: ${successes.join(', ')} ✅, mas ocorreram erros em: ` +
        failures.map(f => `${f.name} (${f.message})`).join(', ')
      );
    } else if (failures.length) {
      toast.error(
        `Não foi possível concluir as solicitações: ` +
        failures.map(f => `${f.name} (${f.message})`).join(', ')
      );
    } else if (successes.length) {
      toast.success(`Solicitações concluídas com sucesso: ${successes.join(', ')}`);
    }
  };


  return (
    <LimitContext.Provider
      value={{
        originalLimits,
        currentLimits,
        limits,
        loading,
        limitIncreaseRequests,

        setOriginalLimits,
        setCurrentLimits,
        setLimits,
        setLoading,
        setLimitIncreaseRequests,

        fetchLimits,
        updateLimits,
        fetchLimitIncreaseRequests,
      }}
    >
      {children}
    </LimitContext.Provider>
  );
}
